import React from "react";
import { useIntl } from "react-intl";

import { BookingFormAreaProps } from "shared/types";

export default function BookingFormArea({
  value,
  onChange,
  name,
  label,
}: BookingFormAreaProps) {
  const intl = useIntl();

  return (
    <>
      <textarea
        className="form-textarea-field"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={
          name === "other_remark"
            ? intl.formatMessage({ id: "Result.commentPlaceholder" })
            : label || ""
        }
      />
    </>
  );
}
